import React, { useState } from 'react';
import { newsAPI } from '../../utils/api';
import { toast } from 'react-toastify';

const NewsTab = ({ 
  news, 
  setNews, 
  showAddNews, 
  setShowAddNews, 
  loading, 
  setLoading,
  loadNews
}) => {
  const [newsForm, setNewsForm] = useState({
    title: '',
    excerpt: '',
    content: '',
    tags: '',
    imageUrl: ''
  });


  const handleNewsFormChange = (e) => {
    const { name, value } = e.target;
    setNewsForm({
      ...newsForm,
      [name]: value
    });
  };

  const handleAddNews = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const tagsArray = newsForm.tags.split(',').map(tag => tag.trim()).filter(tag => tag);

      const newsData = {
        title: newsForm.title,
        excerpt: newsForm.excerpt,
        content: newsForm.content,
        tags: tagsArray,
        imageUrl: newsForm.imageUrl
      };

      const response = await newsAPI.createNews(newsData);
      if (response.success) {
        toast.success('News wurde erfolgreich erstellt!');
        setNewsForm({
          title: '',
          excerpt: '',
          content: '',
          tags: '',
          imageUrl: ''
        });
        setShowAddNews(false);
        await loadNews();
      }
    } catch (error) {
      console.error('Fehler beim Erstellen der News:', error);
      toast.error(error.message || 'Fehler beim Erstellen der News');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNews = async (newsId) => {
    if (window.confirm('Möchten Sie diesen Artikel wirklich löschen?')) {
      try {
        const response = await newsAPI.deleteNews(newsId);
        if (response.success) {
          toast.success('Artikel wurde gelöscht!');
          await loadNews();
        }
      } catch (error) {
        console.error('Fehler beim Löschen der News:', error);
        toast.error(error.message || 'Fehler beim Löschen der News');
      }
    }
  };

  return (
    <div className="news-tab">
      <div className="news-header">
        <h2>News-Verwaltung</h2>
        <button 
          onClick={() => setShowAddNews(!showAddNews)} 
          className="btn btn-primary"
        >
          <span className="icon">📰</span>
          {showAddNews ? 'Abbrechen' : 'News erstellen'}
        </button>
      </div>

      {showAddNews && (
        <div className="add-form">
          <h3>Neue News erstellen</h3>
          <form onSubmit={handleAddNews}>
            <div className="form-group">
              <label>Titel:</label>
              <input
                type="text"
                name="title"
                value={newsForm.title}
                onChange={handleNewsFormChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Kurzbeschreibung:</label>
              <textarea
                name="excerpt"
                value={newsForm.excerpt}
                onChange={handleNewsFormChange}
                rows="3"
                required
              />
            </div>

            <div className="form-group">
              <label>Inhalt:</label>
              <textarea
                name="content"
                value={newsForm.content}
                onChange={handleNewsFormChange}
                rows="8"
                required
              />
            </div>

            <div className="form-group">
              <label>Tags (kommagetrennt):</label>
              <input
                type="text"
                name="tags"
                value={newsForm.tags}
                onChange={handleNewsFormChange}
                placeholder="z.B. Bundesliga, Spiel, Heimspiel"
              />
            </div>

            <div className="form-group">
              <label>Bild-URL (optional):</label>
              <input
                type="url"
                name="imageUrl"
                value={newsForm.imageUrl}
                onChange={handleNewsFormChange}
                placeholder="https://..."
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-success" disabled={loading}>
                {loading ? 'Erstelle...' : 'News erstellen'}
              </button>
              <button 
                type="button" 
                onClick={() => setShowAddNews(false)} 
                className="btn btn-secondary"
              >
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="news-list">
        {news.length === 0 ? (
          <p>Keine News vorhanden.</p>
        ) : (
          news.map((article) => (
            <div key={article.id} className="news-item">
              <div className="news-content">
                <h4>{article.title}</h4>
                <p className="excerpt">{article.excerpt}</p>
                <div className="news-meta">
                  <span>Erstellt: {new Date(article.created_at).toLocaleDateString('de-DE')}</span>
                  {article.tags && (
                    <div className="tags">
                      {article.tags.split(',').map((tag, index) => (
                        <span key={index} className="tag">{tag.trim()}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="news-actions">
                <button 
                  onClick={() => handleDeleteNews(article.id)}
                  className="btn btn-danger btn-sm"
                >
                  <span className="icon">🗑️</span>
                  Löschen
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NewsTab;
